import { render, staticRenderFns } from "./register-email-verified.vue?vue&type=template&id=08c18b61&"
import script from "./register-email-verified.vue?vue&type=script&lang=js&"
export * from "./register-email-verified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports